const isNonEmptyString = (value) =>
  typeof value === 'string' && value.trim().length > 0;

export const isValidAuthSession = (session) =>
  isNonEmptyString(session?.token) && isNonEmptyString(session?.path);
